import React, { useContext, useEffect, useState } from 'react'
import { useLocation, NavLink } from 'react-router-dom'
import { withTranslation } from 'react-i18next'
import Collapse from '@material-ui/core/Collapse'
import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'
import List from '@material-ui/core/List'
import { dashRoutes } from 'pages/Admin/routes.js'
import { GetThemeColorFromStorage } from 'redux/api/themeColor'
import { useHistory } from 'react-router-dom'
import _ from 'lodash'

import {
    ListItemIconMenu,
    ListItemMenu,
    ListItemTextMenu,
    ListSubItem,
    CustomList,
} from './styles'
import { removeRoutes, useStyles } from './utils'
import { MuiBox } from '../storybook'
import ModalSimplifiedWarning from '../ModalSimplifiedWarning'
import { useSelector } from 'react-redux'
import { SkeletonSideMenu } from './components/SkeletonSideMenu'
import GeneralContext from '../../Context'

function SideMenu({ t, handleDrawerToggle }) {
    const classes = useStyles()
    const history = useHistory()
    const location = useLocation()
    const { GeneralRules } = useContext(GeneralContext)
    const { users } = useSelector((state) => state)

    const [id, setId] = useState()
    const [open, setOpen] = useState(false)
    const [focuses, setFocuses] = useState('')
    const [simplifiedAlert, setSimplifiedAlert] = useState(false)

    const allowIndications = localStorage.getItem('allowIndications')

    const [newRoutes, setNewRoutes] = useState([])

    useEffect(() => {
        if (!_.isEmpty(GeneralRules)) {
            processGeneralRules(GeneralRules)
        }
    }, [GeneralRules, users?.userData?.status_value])

    useEffect(() => {
        setFocuses('')
        verifyFocus()
    }, [location])

    const processGeneralRules = (generalRules) => {
        try {
            const updatedRoutes = removeRoutes(
                generalRules,
                dashRoutes,
                users?.userData?.status_value,
            )
            setNewRoutes(updatedRoutes)
        } catch (error) {
            console.error('Failed to load general basic data:', error)
        }
    }

    if (_.isEmpty(GeneralRules)) {
        return <SkeletonSideMenu />
    }

    const handleClick = (routeId) => {
        if (id === routeId) {
            setId('')
            return setOpen(false)
        }
        setOpen(routeId)
        setId(routeId)
    }

    function focus(path) {
        var currentUrl = window.location.pathname
        if (path === currentUrl) {
            return true
        }
    }

    function verifyFocus() {
        var firstPath = window.location.pathname.split('/')[1]
        var currentUrl = window.location.pathname
        newRoutes.forEach((item) => {
            if (item.collapse === true) {
                item.views.map((view) => {
                    if (view.path === currentUrl) {
                        if (view.focus) {
                            setFocuses(view.focus)
                            return setOpen(view.id)
                        } else {
                            focus(view.path)
                            return setOpen(view.id)
                        }
                    } else {
                        if (currentUrl.includes(firstPath)) {
                            if (firstPath === view.path.split('/')[1]) {
                                if (view.focus) {
                                    setFocuses(view.focus)
                                    return setOpen(view.id)
                                }
                            }
                        }
                    }
                })
            } else {
                if (currentUrl.includes(firstPath)) {
                    if (firstPath === item.path.split('/')[1]) {
                        if (item.focus) {
                            setFocuses(item.id)
                            return setOpen(item.id)
                        }
                    }
                }
            }
        })
    }

    const dinamicMenuItemStyle = (_isDisabled) => {
        if (_isDisabled === true) {
            return {
                cursor: 'default',
                pointerEvents: 'none',
            }
        }

        return {
            cursor: 'pointer',
            pointerEvents: 'auto',
        }
    }

    const handleMenuItemClick = (event, simpleBlocked) => {
        if (users?.userData?.status_value === 'SIMPLIFY' && simpleBlocked) {
            event.preventDefault()
            setSimplifiedAlert(true)
        } else {
            handleDrawerToggle && handleDrawerToggle()
            setSimplifiedAlert(false)
        }
    }

    const MenuItemWithHover = ({ route, key }) => {
        const [iconColor, setIconColor] = useState('#878787')

        return (
            <div style={dinamicMenuItemStyle(false)} key={key}>
                <NavLink
                    to={route.path}
                    onClick={(e) =>
                        handleMenuItemClick(e, route?.simpleBlocked)
                    }
                >
                    <ListItemMenu
                        theme={
                            focuses === route.path ? 'true' : focus(route.path)
                        }
                        _themeColor={
                            GetThemeColorFromStorage() &&
                            GetThemeColorFromStorage()?.navigation &&
                            GetThemeColorFromStorage()?.navigation.menu
                        }
                        first={key === 0 ? true : false}
                        onMouseOver={() => {
                            if (route.svgIcon) {
                                setIconColor('#fff')
                            }
                        }}
                        onMouseOut={() => {
                            if (route.svgIcon) {
                                setIconColor('#878787')
                            }
                        }}
                    >
                        <ListItemIconMenu
                            theme={
                                focuses === route.path
                                    ? 'true'
                                    : focus(route.path)
                            }
                        >
                            <MuiBox
                                sx={{
                                    width: '100%',
                                    height: '100%',
                                    '.iconMenu:hover  svg .iconMenu.true svg': {
                                        fill: '#fff',
                                    },
                                }}
                            >
                                <div
                                    id="listMenu"
                                    className={`iconMenu ${
                                        focuses === route.path ? 'true' : ''
                                    }`}
                                >
                                    {(route.svgIcon &&
                                        route.svgIcon(
                                            focus(route.path)
                                                ? '#fff'
                                                : iconColor,
                                        )) || <i className={route.icon} />}
                                </div>
                            </MuiBox>
                        </ListItemIconMenu>

                        <ListItemTextMenu primary={t(route.name)} />
                    </ListItemMenu>
                </NavLink>
            </div>
        )
    }

    return (
        <CustomList
            component="nav"
            aria-labelledby="nested-list-subheader"
            className={classes.root}
            key={classes.root}
        >
            {newRoutes
                .filter((x) => allowIndications || x.id !== 'friends')
                .map((route, key) =>
                    route.sidebar && !route.collapse ? (
                        <MenuItemWithHover route={route} key={key} />
                    ) : route.sidebar && route.collapse ? (
                        <div style={dinamicMenuItemStyle(false)} key={route.id}>
                            <ListItemMenu
                                button
                                onClick={() => handleClick(route.id)}
                                _themeColor={
                                    GetThemeColorFromStorage()?.navigation?.menu
                                }
                            >
                                <ListItemIconMenu
                                    theme={focuses === route.path}
                                >
                                    <i className={route.icon} />
                                </ListItemIconMenu>
                                <ListItemTextMenu primary={t(route.name)} />
                                {open === route.id ? (
                                    <ExpandLess />
                                ) : (
                                    <ExpandMore />
                                )}
                            </ListItemMenu>
                            {route.views.map((subItem) =>
                                subItem.sidebar ? (
                                    <Collapse
                                        in={open === subItem.id}
                                        key={subItem.id}
                                        timeout="auto"
                                        unmountOnExit
                                        style={{ width: '284px' }}
                                    >
                                        <List component="div" disablePadding>
                                            <NavLink
                                                to={subItem.path}
                                                onClick={(e) =>
                                                    handleMenuItemClick(
                                                        e,
                                                        subItem?.simpleBlocked,
                                                    )
                                                }
                                            >
                                                <ListSubItem
                                                    theme={
                                                        focuses === subItem.path
                                                    }
                                                    button
                                                    className={classes.nested}
                                                    _themeColor={
                                                        GetThemeColorFromStorage()
                                                            ?.navigation?.menu
                                                    }
                                                >
                                                    <ListItemIconMenu
                                                        theme={
                                                            focuses ===
                                                            subItem.path
                                                        }
                                                    >
                                                        <i
                                                            className={
                                                                subItem.icon
                                                            }
                                                        />
                                                    </ListItemIconMenu>
                                                    <ListItemTextMenu
                                                        primary={t(
                                                            subItem.name,
                                                        )}
                                                    />
                                                </ListSubItem>
                                            </NavLink>
                                        </List>
                                    </Collapse>
                                ) : (
                                    ''
                                ),
                            )}
                        </div>
                    ) : (
                        ''
                    ),
                )}
            <div
                style={{
                    borderBottomStyle: 'solid',
                    borderWidth: '15px',
                    color: '#eee',
                    borderBottomLeftRadius: '10px',
                    WebkitBorderBottomRightRadius: '10px',
                    width: '284px',
                }}
            ></div>
            {simplifiedAlert && (
                <ModalSimplifiedWarning
                    open={simplifiedAlert}
                    onConfirm={() => {
                        setSimplifiedAlert(false)
                        history.push('/profile?edit=true')
                    }}
                    handleClose={() => {
                        setSimplifiedAlert(false)
                    }}
                />
            )}
        </CustomList>
    )
}

export default withTranslation()(SideMenu)
